// Built-in names that make up the "PermanentFile" (תיק קבע) section when a type has no custom title.
export const PERMANENT_FILE_NAMES = new Set([
    "מסמכי יסוד",
    "מוסדות",
    "הצהרת הון",
    "דוחות שנתיות",
    "חוזים"
]);

export const isPermanentFileName = (name) => PERMANENT_FILE_NAMES.has(name);

// Name of the default title seeded for every accountant (hidden from the client by default).
export const PERMANENT_FILE_TITLE_NAME = "תיק קבע";

// A type with a titleId pointing at an unknown title (e.g. titles failed to load) falls back to the legacy split.
const resolveTitleId = (type, titleIds) => {
    const titleId = type?.titleId;
    return titleId && titleIds.has(titleId) ? titleId : null;
};

export function splitOtherDocumentTypes(types = [], titles = []) {
    const safeTypes = Array.isArray(types) ? types : [];
    const safeTitles = Array.isArray(titles) ? titles : [];
    const titleIds = new Set(safeTitles.map((title) => title.id));
    const typesByTitle = new Map(safeTitles.map((title) => [title.id, []]));
    const otherDocuments = [];
    const permanentFiles = [];

    safeTypes.forEach((type) => {
        const titleId = resolveTitleId(type, titleIds);
        if (titleId) {
            typesByTitle.get(titleId).push(type);
        } else if (isPermanentFileName(type?.name)) {
            permanentFiles.push(type);
        } else {
            otherDocuments.push(type);
        }
    });

    const customTitles = safeTitles.map((title) => ({ title, types: typesByTitle.get(title.id) || [] }));

    return { otherDocuments, permanentFiles, customTitles };
}

// Types shown on the OtherDocument page for the section it was opened on.
export function getTypesForSection(types = [], titles = [], { titleId = null, isPermanent = false } = {}) {
    const { otherDocuments, permanentFiles, customTitles } = splitOtherDocumentTypes(types, titles);
    if (titleId) {
        return customTitles.find((entry) => entry.title.id === titleId)?.types || [];
    }
    return isPermanent ? permanentFiles : otherDocuments;
}

export function findTitleForType(typeName, types = [], titles = []) {
    const type = (Array.isArray(types) ? types : []).find((t) => t?.name === typeName);
    if (!type?.titleId) return null;
    return (Array.isArray(titles) ? titles : []).find((title) => title.id === type.titleId) || null;
}
